package com.exura.ui


import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.ms

object Durations {
    val short: CSSSizeValue<CSSUnit.ms> = 200.ms

    val loaderCycle: CSSSizeValue<CSSUnit.ms> = 1800.ms
    const val SNACK_MESSAGE_LIFETIME_MS: Long = 3000 // ms
}
